import React from 'react';
import '../styles/components/Contact.css';

const Contact = () => {
  return (
    <section className="contact-section">
        <div className="contact-container">
          <div className="contact-content-wrapper">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div className="contact-details">
                  <h3 className="contact-item-title">Location</h3>
                  <p className="contact-item-text">
                    Ali Hassan Mwinyi Road, Kijitonyama (Sayansi)
                    <br />
                    COSTECH Building, Dar es Salaam, Tanzania
                  </p>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div className="contact-details">
                  <h3 className="contact-item-title">Email</h3>
                  <a href="mailto:dg@costech.or.tz" className="contact-item-link">
                    dg@costech.or.tz
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div className="contact-details">
                  <h3 className="contact-item-title">Call</h3>
                  <a href="tel:+255738746509" className="contact-item-link">
                    +255 738746509
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-map-wrapper">
              <div className="map-wrapper">
                <iframe
                  src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.234567890123!2d39.23456789012345!3d-6.789012345678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwNDclMjAuNCJTIDM5wrAxNCcwNC40IkU!5e0!3m2!1sen!2stz!4v1234567890123!5m2!1sen!2stz&q=COSTECH+Building+Ali+Hassan+Mwinyi+Road+Kijitonyama+Dar+es+Salaam+Tanzania`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="COSTECH Location"
                ></iframe>
                <div className="map-location-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default Contact;

